import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { HexonOverview } from './overview';

const Container = styled.div``;
const STATE = {
  selected: null,
};
/* eslint-disable react/prefer-stateless-function */
class HexonPageComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container>
        <Switch>
          <Route component={HexonOverview} />
        </Switch>
      </Container>
    );
  }
}

HexonPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const HexonPage = compose(
  withConnect,
  withRouter,
)(HexonPageComp);
